import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RedemptionDetailCpt = _resolveComponent("RedemptionDetailCpt");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page",
    title: "赎回详情"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_pull_refresh, {
      modelValue: $data.isPullRefreshing,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.isPullRefreshing = $event),
      onRefresh: $options.onPullRefresh
    }, {
      default: _withCtx(() => [_createVNode(_component_RedemptionDetailCpt, {
        ref: "RedemptionDetail"
      }, null, 512)]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])]),
    _: 1
  });
}